import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogContent,
  FormHelperText
} from "@mui/material";
import { useMutation } from "@apollo/client";
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { DialogTitleComp } from "../../Utils/Component";
import { SelectDatePicker } from "../Include/SelectDatePicker";
import { useGetNextNumberingOfWorkGroup } from "../../Hooks/useGetNextNumberingOfWorkGroup";
import { CREATE_PUBLIC_FORUM, UPDATE_PUBLIC_FORUM } from "../../Schema/PublicForum";
import {SelectDistrict} from "../Include/DynamicSelect";
import moment from "moment";

// import ProvincailCouncilList from "./ProvincailCouncilList/ProvincailCouncilList";
// import SecretaryList from "./SecretaryList/SecretaryList";

export default function PublicForumForm({
  open,
  editData,
  setRefetch,
  handleClose,
  dialogTitle,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createPublicForum] = useMutation(CREATE_PUBLIC_FORUM, {
    onCompleted: ({ createPublicForum }) => {
      setLoading(false);
      if (createPublicForum?.isSuccess === true) {
        setAlert(true, "success", createPublicForum?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createPublicForum?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updatePublicForum] = useMutation(UPDATE_PUBLIC_FORUM, {
    onCompleted: ({ updatePublicForum }) => {
      setLoading(false);
      if (updatePublicForum?.isSuccess === true) {
        setAlert(true, "success", updatePublicForum?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updatePublicForum?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });
  
  //fromik
  const CheckValidation = Yup.object().shape({
    districtMunicipalityId: Yup.object().shape({
      id: Yup.string().required(true),
      title: Yup.string(),
    }),
    publicForumTitle: Yup.string(),
    publicForumDescription: Yup.string(),
    startDate: Yup.string(),
    endDate: Yup.string(),
    
  });

  const formik = useFormik({
    initialValues: {
        districtMunicipalityId: {id: "", title: ""},
        publicForumTitle: "វេទិការសាធារៈរបស់ក្រុមប្រឹក្សាខេត្ត",
        publicForumDescription: "",
        startDate: moment(),
        endDate: moment(),
    },

    validationSchema: CheckValidation,

    onSubmit: async (values) => {
      setLoading(true);
      const inputData = {
        districtMunicipalityId: values?.districtMunicipalityId?.id,
        publicForumTitle: values?.publicForumTitle,
        publicForumDescription: values?.publicForumDescription,
        startDate: values?.startDate,
        endDate: values?.endDate,
      }
    
      if (dialogTitle === "Update") {

        updatePublicForum({
          variables: {
            id: editData?._id,
            input: inputData,
          },
        });
      } else {
        
        createPublicForum({
          variables: {
            input: inputData,
          },
        });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  const {numbering, refetch } = useGetNextNumberingOfWorkGroup({setFieldValue});
 
  useEffect(() => {
    refetch();
    if (dialogTitle === "Create") {
      setFieldValue("numbering", numbering);
    }
  }, [dialogTitle, open]);

  useEffect(() => {
    if (editData) {
        setFieldValue("districtMunicipalityId", {id: editData?.districtMunicipalityId?._id, title: editData?.districtMunicipalityId?.district_municipality_name_kh});
        setFieldValue("publicForumTitle", editData?.publicForumTitle);
        setFieldValue("publicForumDescription", editData?.publicForumDescription);
        setFieldValue("startDate", editData?.startDate);
        setFieldValue("endDate", editData?.endDate);
    }
  }, [editData, open]);
 
  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm" fullWidth>
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_public_forum")
            : t("modal_title_update_public_forum")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers >
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2.5} columnSpacing={1}>

                <Grid item xs={12}>
                    <Typography className={t("class-name-field-title")}>
                    {t("thead_municipality_district")}
                    </Typography>
                    <SelectDistrict
                        dialogTitle={dialogTitle}
                        capicalProvincesId={"65f3a1b2c4d5e6f7a8b9c0e1"}
                        value={values?.districtMunicipalityId}
                        onChange={(val) => {
                        setFieldValue(
                            "districtMunicipalityId",
                            val
                        );
                        }}
                        helperText={
                        touched.districtMunicipalityId?.id &&
                        errors.districtMunicipalityId?.id
                        }
                        error={Boolean(
                        touched.districtMunicipalityId?.id &&
                            errors.districtMunicipalityId?.id
                        )}
                    />
                </Grid>

              <Grid item xs={12} >
                <Typography className={t("class-name-field-title")}>
                  {t("thead_public_forum_title")}
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_public_forum_title")}
                  {...getFieldProps("publicForumTitle")}
                  error={Boolean(touched.publicForumTitle && errors.publicForumTitle)}
                  helperText={touched.publicForumTitle && errors.publicForumTitle}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_start_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.startDate}
                  onChange={(val) => setFieldValue("startDate", val)}
                />
                {!!errors?.startDate && touched?.startDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors?.startDate}
                  </FormHelperText>
                )}
              </Grid>
              
              <Grid item xs={6}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_end_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.endDate}
                  onChange={(val) => setFieldValue("endDate", val)}
                />
                {!!errors?.endDate && touched?.endDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors?.endDate}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_description")}
                </Typography>
                <TextField
                  className="text-field"
                  multiline
                  rows={2}
                  size="small"
                  fullWidth
                  placeholder={t("thead_description")}
                  {...getFieldProps("publicForumDescription")}
                  error={Boolean(touched.publicForumDescription && errors.publicForumDescription)}
                  helperText={touched.publicForumDescription && errors.publicForumDescription}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Update" ? t("update") : t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
